import { memo, type FC } from "react";
import { StatusCardContainer } from "@src/components/CameraDetails";
import { StatusRow, SimpleIcon, NavigationRowRightContent } from "./StatusRow";
import { NavPressable } from "@src/components/NavPressable";
import { ActivityLastDayHeatmap } from "@src/features/clips";
import type { Href } from "expo-router";

interface ScheduleMenuCardProps {
  scheduleStatus: string;
  alertsCount: number;
  siteId: string;
  cameraKey: string;
  timezone: string;
  onAlarmSettingsPress: () => void;
  onActivityAlertsPress: () => void;
  alarmSettingsHref?: Href;
  activityAlertsHref?: Href;
}

export const ScheduleMenuCard: FC<ScheduleMenuCardProps> = memo(
  ({
    scheduleStatus,
    alertsCount,
    siteId,
    cameraKey,
    timezone,
    onAlarmSettingsPress,
    onActivityAlertsPress,
    alarmSettingsHref,
    activityAlertsHref,
  }) => {
    const clipsText = alertsCount === 1 ? "1 clip past 24 hrs" : `${alertsCount} clips past 24 hrs`;

    return (
      <StatusCardContainer title="Schedule">
        {/* Alarm Settings Row */}
        {alarmSettingsHref ?
          <NavPressable href={alarmSettingsHref}>
            <StatusRow
              icon={<SimpleIcon name="calendarOutline" />}
              title="Alarm settings"
              rightContent={<NavigationRowRightContent value={scheduleStatus} />}
            />
          </NavPressable>
        : <StatusRow
            icon={<SimpleIcon name="calendarOutline" />}
            title="Alarm settings"
            rightContent={<NavigationRowRightContent value={scheduleStatus} />}
            onPress={onAlarmSettingsPress}
          />
        }

        {/* Activity Alerts Row with Heatmap */}
        {activityAlertsHref ?
          <NavPressable href={activityAlertsHref}>
            <StatusRow
              icon={<SimpleIcon name="activity" />}
              title="Activity alerts"
              rightContent={<NavigationRowRightContent value={clipsText} />}
              bottomContent={<ActivityLastDayHeatmap siteId={siteId} cameraKey={cameraKey} timezone={timezone} />}
            />
          </NavPressable>
        : <StatusRow
            icon={<SimpleIcon name="activity" />}
            title="Activity alerts"
            rightContent={<NavigationRowRightContent value={clipsText} />}
            bottomContent={<ActivityLastDayHeatmap siteId={siteId} cameraKey={cameraKey} timezone={timezone} />}
            onPress={onActivityAlertsPress}
          />
        }
      </StatusCardContainer>
    );
  },
);
